/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function BackgroundImage(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'BackgroundImage',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 13 * scale,
      viewBox: '0 0 16 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M14.2 1H1.8c-.4 0-.8.4-.8.8v9.4c0 .4.4.8.8.8h12.4c.4 0 .8-.4.8-.8V1.8c0-.4-.4-.8-.8-.8M3 4.5C3 3.7 3.7 3 4.5 3S6 3.7 6 4.5 5.3 6 4.5 6 3 5.3 3 4.5M4 10l6-5 3 5z"}))
}
